import { X, Home, Phone, Cake, Mail, Wallet, ContactRound, Pencil, LocateFixed } from 'lucide-react';
import React, { useState, useEffect, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";








import { updateProviderResourceDetails } from "../../../../../services/staffingService";



// Validation schema for Details
const detailsSchema = yup.object().shape({
  // address: yup.string().required("Address is required"),
  location: yup.string().required("Your location is required."),
  phoneNumber: yup.string().required("Phone number is required"),
  dateOfBirth: yup.date().required("Date of birth is required"),
  //email: yup.string().email("Invalid email").required("Email is required"),
  emergencyContactName: yup
    .string()
    .required("Emergency contact name is required"),
  emergencyContactPhone: yup
    .string()
    .required("Emergency contact phone is required"),
});

const Details = ({ officerData: initialOfficerData, providerCompanyId }) => {
  
  const [officerData, setOfficerData] = useState(initialOfficerData);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);

  const {
    register,
    handleSubmit,
    control,
    setValue, 
    formState: { errors },
  } = useForm({
    resolver: yupResolver(detailsSchema),
    defaultValues: {
      location: officerData.formattedLocation,
      phoneNumber: officerData.phoneNumber,
      dateOfBirth: officerData.dateOfBirth ? new Date(officerData.dateOfBirth).toISOString().split('T')[0] : '',
      //email: officerData.user_id?.email,
      emergencyContactName: officerData.emergencyContact?.name,
      emergencyContactPhone: officerData.emergencyContact?.phone,

        city : officerData.city,
        formatted_address : officerData.formattedLocation,
        latitude : officerData.latitude,
        // location : officerData.formattedLocation,
        longitude : officerData.longitude, 
        state : officerData.state,
        zipcode  : officerData.zipcode
    },
  });

  useEffect(() => {
    setOfficerData(initialOfficerData);
    // Reset form values when officer data changes
    setValue('location', initialOfficerData.formattedLocation);
    setValue('phoneNumber', initialOfficerData.phoneNumber);
    setValue('dateOfBirth', initialOfficerData.dateOfBirth ? new Date(initialOfficerData.dateOfBirth).toISOString().split('T')[0] : '');
    setValue('emergencyContactName', initialOfficerData.emergencyContact?.name);
    setValue('emergencyContactPhone', initialOfficerData.emergencyContact?.phone);
  }, [initialOfficerData, setValue]);

  const toggleEditMode = () => {
    setIsEditing(!isEditing);
    // Debug: Check if Google Maps is available
    if (!window.google || !window.google.maps || !window.google.maps.places) {
      console.warn('Google Maps API not loaded properly. Please check if the Google Maps script is included.');
    }
  };

  
const Autocomplete = ({ value, onPlaceSelected }) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (!window.google || !window.google.maps || !window.google.maps.places) {
      return;
    }

    const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
      componentRestrictions: { country: "us" },
    });

    // Add listener for place_changed
    const listener = autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      
      if (place && place.address_components) {
        onPlaceSelected(place);
      }
    });

    // Cleanup
    return () => {
      window.google.maps.event.removeListener(listener);
    };
  }, [onPlaceSelected]);

  return (
    <div className="relative w-full">
      <input
        type="text"
        ref={inputRef}
        className="form-input pr-10"
        defaultValue={value}
        placeholder="Enter your address"
      />
      <LocateFixed className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-xl pointer-events-none" />
    </div>
  );
};
  
  
  
  const onPlaceSelected = (place) => {
    const addressComponents = place.address_components;
    const locationData = {
      formatted_address: place.formatted_address,
      latitude: place.geometry.location.lat(),
      longitude: place.geometry.location.lng(),
      state: "",
      city: "",
      zipcode: "",
    };
  
    addressComponents.forEach((component) => {
      const types = component.types;
      if (types.includes("administrative_area_level_1")) {
        locationData.state = component.long_name;
      }
      if (types.includes("locality")) {
        locationData.city = component.long_name;
      }
      if (types.includes("postal_code")) {
        locationData.zipcode = component.long_name;
      }
    });
  
    setSelectedLocation(locationData);
    setValue("location", locationData.formatted_address);
  };
  
  const handleCancel = () => {
    setSelectedLocation(null);
    setValue("location", "");
  };

  const onSubmit = async (data) => {
    try {
      // Make the API call to update the details
      await updateProviderResourceDetails(providerCompanyId, officerData._id, {
        selectedLocation,
        data
      });


      setOfficerData((prevData) => ({
        ...prevData,
        formattedLocation: selectedLocation?.formatted_address || prevData.formattedLocation,
        city: selectedLocation?.city || prevData.city,
        latitude: selectedLocation?.latitude || prevData.latitude,
        longitude: selectedLocation?.longitude || prevData.longitude,
        state: selectedLocation?.state || prevData.state,
        zipcode: selectedLocation?.zipcode || prevData.zipcode,
        phoneNumber: data.phoneNumber,
        dateOfBirth: data.dateOfBirth,
        emergencyContact: {
          name: data.emergencyContactName,
          phone: data.emergencyContactPhone,
        },
      }))

      setIsEditing(false);
    } catch (error) {
      console.error("Failed to update details:", error);
    }
  };

  function calculateAge(birthDate) {
    const birth = new Date(birthDate);
    const today = new Date();
    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
      age--;
    }
    return age;
  }

 
  return (
    <div className="font-inter">
      {!isEditing ? (
        <div className="space-y-4">
          <div className="space-y-0.5">
            <label className="text-xs font-medium text-[var(--muted-foreground)] uppercase tracking-wide">Address</label>
            <div className="flex items-center gap-2">
              <Home className="text-[var(--brand-pink)]" style={{ fontSize: '14px' }} />
              <p className="text-[var(--foreground)] font-medium text-sm">{officerData.formattedLocation || 'Not specified'}</p>
            </div>
          </div>

          <div className="space-y-0.5">
            <label className="text-xs font-medium text-[var(--muted-foreground)] uppercase tracking-wide">Phone Number</label>
            <div className="flex items-center gap-2">
              <Phone className="text-[var(--brand-pink)]" style={{ fontSize: '14px' }} />
              {officerData.phoneNumber ? (
                <a 
                  href={`tel:${officerData.phoneNumber}`}
                  className="text-[var(--primary)] font-medium hover:underline text-sm"
                >
                  {officerData.phoneNumber}
                </a>
              ) : (
                <p className="text-[var(--foreground)] font-medium text-sm">Not specified</p>
              )}
            </div>
          </div>

          <div className="space-y-0.5">
            <label className="text-xs font-medium text-[var(--muted-foreground)] uppercase tracking-wide">Date of Birth</label>
            <div className="flex items-center gap-2">
              <Cake className="text-[var(--brand-pink)]" style={{ fontSize: '14px' }} />
              <p className="text-[var(--foreground)] font-medium text-sm">
                {officerData.dateOfBirth ? (
                  `${new Date(officerData.dateOfBirth).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })} (${calculateAge(officerData.dateOfBirth)} years old)`
                ) : 'Not specified'}
              </p>
            </div>
          </div>

          <div className="space-y-0.5">
            <label className="text-xs font-medium text-[var(--muted-foreground)] uppercase tracking-wide">Email Address</label>
            <div className="flex items-center gap-2">
              <Mail className="text-[var(--brand-pink)]" style={{ fontSize: '14px' }} />
              {officerData.user_id?.email ? (
                <a 
                  href={`mailto:${officerData.user_id.email}`}
                  className="text-[var(--primary)] font-medium hover:underline text-sm"
                >
                  {officerData.user_id.email}
                </a>
              ) : (
                <p className="text-[var(--foreground)] font-medium text-sm">Not specified</p>
              )}
            </div>
          </div>

          <div className="space-y-0.5">
            <label className="text-xs font-medium text-[var(--muted-foreground)] uppercase tracking-wide">Stripe Account</label>
            <div className="flex items-center gap-2">
              <Wallet className="text-[var(--brand-pink)]" style={{ fontSize: '14px' }} />
              <p className="text-[var(--foreground)] font-medium text-sm">
                {officerData.stripeAccount?.id || 'Not connected'}
              </p>
            </div>
          </div>

          <div className="space-y-0.5">
            <label className="text-xs font-medium text-[var(--muted-foreground)] uppercase tracking-wide">Emergency Contact</label>
            <div className="flex items-center gap-2">
              <ContactRound className="text-[var(--brand-pink)]" style={{ fontSize: '14px' }} />
              <p className="text-[var(--foreground)] font-medium text-sm">
                {officerData.emergencyContact ? (
                  <>
                    {officerData.emergencyContact.name}
                    {officerData.emergencyContact.phone && (
                      <span className="text-[var(--muted-foreground)]"> ({officerData.emergencyContact.phone})</span>
                    )}
                  </>
                ) : 'Not specified'}
              </p>
            </div>
          </div>

          <div className="flex justify-end pt-6 border-t border-[var(--border)]">
            <button
              onClick={toggleEditMode}
              className="inline-flex items-center gap-2 px-5 py-2.5 text-[var(--primary)] bg-transparent border border-[var(--primary)] rounded-lg hover:bg-[var(--primary)] hover:text-white transition-all duration-200 font-medium text-sm"
            >
              <Pencil style={{ fontSize: '16px' }} />
              Edit Details
            </button>
          </div>
        </div>
      ) : (
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
          {/* <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Address</label>
            {selectedLocation ? (
              <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg border">
                <span className="text-gray-900">{selectedLocation.formatted_address}</span>
                <button
                  type="button"
                  onClick={handleCancel}
                  className="text-gray-400 hover:text-gray-600 transition-colors"
                >
                  <X className="text-lg" />
                </button>
              </div>
            ) : (
              <Controller
                name="location"
                control={control}
                render={({ field }) => (
                  <Autocomplete
                    value={field.value || officerData.formattedLocation}
                    onPlaceSelected={(place) => {
                      field.onChange(place.formatted_address);
                      onPlaceSelected(place);
                    }}
                  />
                )}
              />
            )}
            {errors.location && (
              <span className="text-red-500 text-sm mt-1 block">{errors.location.message}</span>
            )}
          </div> */}
  <div >
          <label className="form-label">Address</label>
            {selectedLocation ? (
              <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg border border-gray-200 text-gray-900 font-inter text-sm">
                <span className="flex-1">{selectedLocation.formatted_address}</span>
                <button
                  type="button"
                  onClick={handleCancel}
                  className="text-gray-400 hover:text-gray-600 transition-colors p-1 rounded hover:bg-gray-100"
                >
                  <X className="text-lg" />
                </button>
              </div>
            ) : (
              <Controller
                name="location"
                control={control}
                render={({ field }) => (
                  <Autocomplete
                    value={field.value || officerData.formattedLocation}
                    onPlaceSelected={(place) => {
                      field.onChange(place.formatted_address);
                      onPlaceSelected(place);
                    }}
                  />
                )}
              />
            )}
            {errors.location && <span className="text-red-500 text-sm mt-1 block font-inter">{errors.location.message}</span>}

          </div>

          <div>
            <label className="form-label">Phone</label>
            <Controller
              name="phoneNumber"
              control={control}
              render={({ field }) => (
                <div className="phone-input-wrapper">
                  <PhoneInput
                    defaultCountry="US"
                    value={field.value}
                    onChange={field.onChange}
                    international
                    countryCallingCodeEditable={false}
                  />
                </div>
              )}
            />
            {errors.phoneNumber && (
              <span className="text-red-500 text-sm mt-1 block font-inter">
                {errors.phoneNumber.message}
              </span>
            )}
          </div>

          <div>
            <label className="form-label">Date of Birth</label>
            <input
              type="date"
              {...register("dateOfBirth")}
              className="form-input"
            />
            {errors.dateOfBirth && (
              <span className="text-red-500 text-sm mt-1 block font-inter">
                {errors.dateOfBirth.message}
              </span>
            )}
          </div>

          <div>
            <label className="form-label">Emergency Contact Name</label>
            <input
              type="text"
              {...register("emergencyContactName")}
              className="form-input"
            />
            {errors.emergencyContactName && (
              <span className="text-red-500 text-sm mt-1 block font-inter">
                {errors.emergencyContactName.message}
              </span>
            )}
          </div>

          <div>
            <label className="form-label">Emergency Contact Phone</label>
            <Controller
              name="emergencyContactPhone"
              control={control}
              render={({ field }) => (
                <div className="phone-input-wrapper">
                  <PhoneInput
                    defaultCountry="US"
                    value={field.value}
                    onChange={field.onChange}
                    international
                    countryCallingCodeEditable={false}
                  />
                </div>
              )}
            />
            {errors.emergencyContactPhone && (
              <span className="text-red-500 text-sm mt-1 block font-inter">
                {errors.emergencyContactPhone.message}
              </span>
            )}
          </div>

          <div className="flex space-x-3 pt-4">
            <button 
              type="submit" 
              className="px-4 py-2 bg-[#404880] text-white rounded-lg hover:bg-[#363e70] transition-colors"
            >
              Save
            </button>
            <button
              type="button"
              onClick={toggleEditMode}
              className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default Details;
